function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import { FormContextProvider, useFormContext } from './FormContext';
import * as S from './Form.styles';
const Form = /*#__PURE__*/React.forwardRef(({
  children,
  orientation,
  inputSize,
  ...formProps
}, ref) => {
  const getContextProps = () => {
    if (orientation === 'horizontal') {
      return {
        orientation,
        inputSize: 'medium'
      };
    }
    return {
      orientation,
      inputSize
    };
  };
  return /*#__PURE__*/React.createElement(FormContextProvider, getContextProps(), /*#__PURE__*/React.createElement(S.StyledForm, _extends({
    ref: ref
  }, formProps), children));
});
const InputGroup = /*#__PURE__*/React.forwardRef(({
  children
}, ref) => {
  return /*#__PURE__*/React.createElement(S.InputGroup, {
    ref: ref,
    role: "group"
  }, children);
});
const FormActions = /*#__PURE__*/React.forwardRef(({
  children
}, ref) => {
  const context = useFormContext();
  return /*#__PURE__*/React.createElement(S.FormActions, {
    ref: ref,
    $inputSize: context?.inputSize
  }, children);
});
export { Form, InputGroup, FormActions };